import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,_vm._l((_vm.items),function(item,i){return _c(VCol,{key:i,attrs:{"cols":"12"}},[_c(VExpansionPanels,{attrs:{"popout":""}},[_c('expandable',_vm._b({},'expandable',item,false))],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }